import { ConfigureDispositionCollapsibleRoot } from "./ConfigureDispositionCollapsibleRoot/ConfigureDispositionCollapsibleRoot";
import { ConfigureDispositionCollapsibleHeader } from "./ConfigureDispositionCollapsibleHeader/ConfigureDispositionCollapsibleHeader";
import { ConfigureDispositionCollapsibleList } from "./ConfigureDispositionCollapsibleList/ConfigureDispositionCollapsibleList";
import { ConfigureDispositionCollapsibleItem } from "./ConfigureDispositionCollapsibleItem/ConfigureDispositionCollapsibleItem";

export const Root = ConfigureDispositionCollapsibleRoot;
export const Header = ConfigureDispositionCollapsibleHeader;
export const List = ConfigureDispositionCollapsibleList;
export const Item = ConfigureDispositionCollapsibleItem;
